import React, { useRef, useEffect } from "react";

export default function TableCheckbox({
  checked = false,
  indeterminate = false,
  onChange,
  disabled = false,
  className = "",
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) ref.current.indeterminate = !checked && indeterminate;
  }, [indeterminate, checked]);

  return (
    <input
      ref={ref}
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      onClick={(e) => e.stopPropagation()}
      style={{ accentColor: "var(--color-brand)" }}
      className={`h-[15px] w-[15px] shrink-0 align-middle rounded ${
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
      } ${className}`}
    />
  );
}
